const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/utils/configToCardMapper.ts';
export type DashboardCardType =
    | 'Medication'
    | 'Appointments'
    | 'BookAppointmentCard'
    | 'NextAppointment'
    | 'NextSurgeryAppointmentCard'
    | 'ECheckin'
    | 'Reports'
    | 'Invoice'
    | 'SynedraViewer'
    | 'Responsibility'
    | 'ExternalLinks'
    | 'IdentityProof'
    | 'HospitalImage';

export enum CardSize {
    L = 'L',
    M = 'M',
    S = 'S',
}

export type DashboardCard = {
    CardType: DashboardCardType;
    CardSize: CardSize;
    Priority: number;
};

export type DashboardCardConfiguration = {
    L: {
        Cards: DashboardCard[];
    };
    M: {
        Cards: DashboardCard[];
    };
    S: {
        Cards: DashboardCard[];
    };
};

const compareNumbers = (a: DashboardCard, b: DashboardCard) => {
    return a.Priority - b.Priority;
};

const getConfigBySize = (config: DashboardCard[], size: CardSize) => {
    return config.filter(entry => entry.CardSize === size).sort(compareNumbers);
};

export const getCardsfromConfig = (config: DashboardCard[]): DashboardCardConfiguration => {
    return {
        L: {
            Cards: getConfigBySize(config, CardSize.L),
        },
        M: {
            Cards: getConfigBySize(config, CardSize.M),
        },
        S: {
            Cards: getConfigBySize(config, CardSize.S),
        },
    };
};
